"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonAmbitionBack = exports.ButtonArrowAmbitionRight = exports.ButtonArrowAmbitionLeft = exports.ButtonArrowProRight = exports.ButtonArrowProLeft = exports.ButtonArrowBigRight = exports.ButtonArrowBigLeft = exports.ButtonArrowRight = exports.ButtonArrowLeft = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _ButtonIcon = _interopRequireDefault(require("@commerce-ui/core2/ButtonIcon"));
var _core = require("@commerce-ui/core2");
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IconChevronLeft = function IconChevronLeft(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.952 12.748l8.133-8.495-.866-.83-8.92 9.316 8.915 9.51.876-.821-8.138-8.68z"
  }));
};
IconChevronLeft.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconChevronRight = function IconChevronRight(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.436 12.748L7.303 4.253l.867-.83 8.92 9.316-8.916 9.51-.875-.821 8.137-8.68z"
  }));
};
IconChevronRight.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconArrowLeft = function IconArrowLeft(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), __jsx("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
  }));
};
IconArrowLeft.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
var IconArrowRight = function IconArrowRight(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), __jsx("path", {
    d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
  }));
};
IconArrowRight.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
var sharedStyles = {
  overflow: "hidden",
  borderRadius: "22px",
  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.15)",
  ":focus": {
    outline: 0
  },
  "::-moz-focus-inner": {
    border: 0
  },
  $background: function $background(_ref) {
    var isHovered = _ref.isHovered;
    return {
      bg: "white",
      opacity: 1,
      transition: "opacity .15s"
    };
  },
  $body: {
    color: "main"
  }
};
var ButtonArrow = (0, _core.createComponent)(_ButtonIcon["default"], _objectSpread({
  height: "44px",
  width: "44px"
}, sharedStyles));
var ButtonArrowPro = (0, _core.createComponent)(_ButtonIcon["default"], {
  height: "42px",
  width: "42px",
  overflow: "hidden",
  borderRadius: "22px",
  boxShadow: "1px 1px 2px 0px rgba(0,0,0,0.3)",
  ":focus": {
    outline: 0
  },
  "::-moz-focus-inner": {
    border: 0
  },
  $background: function $background(_ref2) {
    var isHovered = _ref2.isHovered;
    return {
      bg: isHovered ? "mono200" : "white",
      opacity: 1,
      transition: "opacity .15s"
    };
  },
  $body: {
    color: "main"
  }
});
var ButtonArrowAmbition = (0, _core.createComponent)(_ButtonIcon["default"], {
  height: "40px",
  width: "40px",
  overflow: "hidden",
  borderRadius: "22px",
  $background: function $background(_ref3) {
    var isHovered = _ref3.isHovered;
    return {
      bg: isHovered ? "main" : "darkGrey",
      transition: "opacity .15s"
    };
  },
  $body: {
    color: "white"
  }
});
var ButtonArrowBack = (0, _core.createComponent)(_ButtonIcon["default"], {
  height: "40px",
  pl: "16px",
  pr: "24px",
  overflow: "hidden",
  borderRadius: "60px",
  $background: function $background(_ref4) {
    var isHovered = _ref4.isHovered;
    return {
      bg: isHovered ? "veryLightGray" : "grayBg",
      transition: "opacity .15s"
    };
  },
  $body: {
    color: "main"
  }
});
var ButtonArrowBig = (0, _core.createComponent)(_ButtonIcon["default"], _objectSpread(_objectSpread({
  height: "55px",
  width: "55px"
}, sharedStyles), {}, {
  borderRadius: "55px"
}));
var ButtonArrowLeft = function ButtonArrowLeft(props) {
  return __jsx(ButtonArrow, props, __jsx(IconChevronLeft, null));
};
exports.ButtonArrowLeft = ButtonArrowLeft;
var ButtonArrowRight = function ButtonArrowRight(props) {
  return __jsx(ButtonArrow, props, __jsx(IconChevronRight, null));
};
exports.ButtonArrowRight = ButtonArrowRight;
var ButtonArrowBigLeft = function ButtonArrowBigLeft(props) {
  return __jsx(ButtonArrowBig, props, __jsx(IconChevronLeft, null));
};
exports.ButtonArrowBigLeft = ButtonArrowBigLeft;
var ButtonArrowBigRight = function ButtonArrowBigRight(props) {
  return __jsx(ButtonArrowBig, props, __jsx(IconChevronRight, null));
};
exports.ButtonArrowBigRight = ButtonArrowBigRight;
var ButtonArrowProLeft = function ButtonArrowProLeft(props) {
  return __jsx(ButtonArrowPro, props, __jsx(IconArrowLeft, null));
};
exports.ButtonArrowProLeft = ButtonArrowProLeft;
var ButtonArrowProRight = function ButtonArrowProRight(props) {
  return __jsx(ButtonArrowPro, props, __jsx(IconArrowRight, null));
};
exports.ButtonArrowProRight = ButtonArrowProRight;
var ButtonArrowAmbitionLeft = function ButtonArrowAmbitionLeft(props) {
  return __jsx(ButtonArrowAmbition, props, __jsx(IconArrowLeft, null));
};
exports.ButtonArrowAmbitionLeft = ButtonArrowAmbitionLeft;
var ButtonArrowAmbitionRight = function ButtonArrowAmbitionRight(props) {
  return __jsx(ButtonArrowAmbition, props, __jsx(IconArrowRight, null));
};
exports.ButtonArrowAmbitionRight = ButtonArrowAmbitionRight;
var ButtonAmbitionBack = function ButtonAmbitionBack(props) {
  return __jsx(ButtonArrowBack, props, __jsx(IconArrowLeft, null), props.children);
};
exports.ButtonAmbitionBack = ButtonAmbitionBack;